<template>
  <b-col cols="12" sm="12">
    <b-card class="mx-auto layered box" tile>
      <b-card-title id="txtAlign">
        <p v-html="$t('configDispositivos.msgConfigDisp', {
          0: '<b>' + this.dispositivo.nombre + '</b>',
          1: '<b>' + getModelo() + '</b>',
        })">
        </p>
      </b-card-title>
      <b-form @submit.stop.prevent="guardarConfiguracion">
        <div class="row">
          <!-- INICIO DE MODO STOP AND GO-->
          <div class="col-12 col-sm-12 col-md-6 col-lg-4 col-xl-4">
            <b-card class="justify-content-center layered box" bg-variant="light" text-variant="black" align="center"
              header-bg-variant="dark">
              <div class="row">
                <b-col cols="3" class="d-flex justify-content-start align-items-center">
                  <b-btn
                    class="d-flex justify-content-center align-items-center btn btn-info text-light rounded-circle layered2 box2 ancho-icono-boton"
                    v-b-tooltip.hover @click="$bvModal.show('bv-modal-stopandgo')"
                    :title="$t('configDispositivos.msgStopGo')">
                    <em class="fas fa-question"></em>
                  </b-btn>
                  <b-modal body-bg-variant="modal" header-bg-variant="modal" id="bv-modal-stopandgo"
                    :title="$t('configDispositivos.msgModalStop')" hide-footer>
                    <p class="my-4 txtJustify" v-html="$t('configDispositivos.msgTextStop', {})"></p>
                    <b-btn class="mt-3" block @click="$bvModal.hide('bv-modal-stopandgo')" style="color: white">
                      {{ $t("Gral.cerrar") }}
                    </b-btn>
                  </b-modal>
                </b-col>
                <b-col cols="7" class="d-flex justify-content-center align-items-center">
                  <h5 class="mb-0" style> {{ $t("configDispositivos.modoStopGo") }} </h5>
                </b-col>
                <b-col cols="2" class="d-flex justify-content-end align-items-center">
                  <b-form-checkbox v-model="alarma.alarmaApagado" switch size="lg">
                  </b-form-checkbox>
                </b-col>
              </div>
              <div v-if="alarma.alarmaApagado" class="row">
                <b-col cols="12" sm="12">
                  <b-form-group id="input-group-3" :label="$t('Gral.tipo') + '* :'" class="alineado-titulo-form">
                    <b-form-select v-model="alarma.tipoApagado" :options="translateAlertas" required
                      style="color: black; background-color: white">
                    </b-form-select>
                  </b-form-group>
                </b-col>
              </div>
            </b-card>
          </div>

          <!-- INICIO DE VELOCIDAD-->
          <b-col class="col-12 col-sm-12 col-sm-4 col-md-6 col-lg-4">
            <b-card class="justify-content-center layered box" bg-variant="light" text-variant="black" align="center"
              header-bg-variant="dark">
              <div class="row">
                <b-col cols="3" class="d-flex justify-content-start align-items-center">
                  <b-btn
                    class="d-flex align-items-center justify-content-center rounded-circle btn btn-info text-light rounded-circle layered2 box2 ancho-icono-boton"
                    @click="$bvModal.show('bv-modal-velocidad')" variant="info" v-b-tooltip.hover
                    :title="$t('configDispositivos.msgTextAlarma')">
                    <em class="fas fa-question"></em>
                  </b-btn>
                  <b-modal body-bg-variant="modal" header-bg-variant="modal" id="bv-modal-velocidad"
                    :title="$t('configDispositivos.msgAlarma')" hide-footer>
                    <p class="my-4"> {{ $t("configDispositivos.msgTextAlarma") }} </p>
                    <b-btn class="mt-3" block @click="$bvModal.hide('bv-modal-velocidad')" style="color: white">
                      {{ $t("Gral.cerrar") }}
                    </b-btn>
                  </b-modal>
                </b-col>
                <b-col cols="7" class="d-flex justify-content-center align-items-center">
                  <h5 class="mb-0" style>{{ $t("vMonitoreo.velocidad") }}:</h5>
                </b-col>
                <b-col cols="2" class="d-flex justify-content-end align-items-center">
                  <b-form-checkbox v-model="alarma.alarmaVelocidad" switch size="lg">
                  </b-form-checkbox>
                </b-col>
              </div>
              <div v-if="alarma.alarmaVelocidad" class="row">
                <b-col cols="12" sm="12">
                  <b-form-group :label="$t('configDispositivos.lblVelocidad')" label-for="move"
                    class="alineado-titulo-form">
                    <b-form-input class="form-input-border" v-model="alarma.velocidad" type="number" min="30" max="999"
                      id="intervalos" required style="color: black; background-color: white">
                    </b-form-input>
                  </b-form-group>
                </b-col>
              </div>
            </b-card>
          </b-col>

          <!-- INICIO MOVIMIENTO -->
          <b-col class="col-12 col-sm-12 col-sm-4 col-md-6 col-lg-4">
            <b-card class="justify-content-center layered box" bg-variant="light" text-variant="black" align="center"
              header-bg-variant="dark">
              <div class="row">
                <b-col cols="3" class="d-flex justify-content-start align-items-center">
                  <b-btn
                    class="d-flex align-items-center justify-content-center rounded-circle btn btn-info text-light rounded-circle layered2 box2 ancho-icono-boton"
                    @click="$bvModal.show('bv-modal-movimiento')" variant="info" v-b-tooltip.hover
                    :title="$t('configDispositivos.msgTextAlarMov')">
                    <em class="fas fa-question"></em>
                  </b-btn>
                  <b-modal body-bg-variant="modal" header-bg-variant="modal" id="bv-modal-movimiento"
                    :title="$t('configDispositivos.msgAlarMov')" hide-footer>
                    <p class="my-4"> {{ $t("configDispositivos.msgTextAlarMov") }} </p>
                    <b-btn class="mt-3" block @click="$bvModal.hide('bv-modal-movimiento')" style="color: white">
                      {{ $t("Gral.cerrar") }}
                    </b-btn>
                  </b-modal>
                </b-col>
                <b-col cols="7" class="d-flex justify-content-center align-items-center">
                  <h5 class="mb-0" style>{{ $t("vMonitoreo.movimiento") }}:</h5>
                </b-col>
                <b-col cols="2" class="d-flex justify-content-end align-items-center">
                  <b-form-checkbox v-model="alarma.alarmaMovimiento" switch size="lg">
                  </b-form-checkbox>
                </b-col>
              </div>
              <div v-if="alarma.alarmaMovimiento" class="row">
                <b-col cols="12" sm="12">
                  <b-form-group :label="$t('configDispositivos.lblIngRadio')" label-for="move"
                    class="alineado-titulo-form">
                    <b-form-input class="form-input-border" v-model="alarma.radio" type="number" min="1" max="9999"
                      id="intervalos2" required style="color: black; background-color: white">
                    </b-form-input>
                  </b-form-group>
                </b-col>
              </div>
            </b-card>
          </b-col>

          <!-- INICIO CONFIGURACION DE ZONA HORARIA-->
          <b-col class="col-12 col-sm-12 col-sm-4 col-md-6 col-lg-4">
            <b-card class="justify-content-center layered box" bg-variant="light" text-variant="black" align="center"
              header-bg-variant="dark">
              <div class="row">
                <b-col cols="3" class="d-flex justify-content-start align-items-center">
                  <b-btn
                    class="d-flex align-items-center justify-content-center rounded-circle btn btn-info text-light rounded-circle layered2 box2 ancho-icono-boton"
                    @click="$bvModal.show('bv-modal-zonaHoraria')" v-b-tooltip.hover
                    :title="$t('configDispositivos.modoZona')">
                    <em class="fas fa-question"></em>
                  </b-btn>
                  <b-modal body-bg-variant="modal" header-bg-variant="modal" id="bv-modal-zonaHoraria"
                    :title="$t('configDispositivos.modoZona')" hide-footer>
                    <p class="my-4" v-html="$t('configDispositivos.msgTextZona')"></p>
                    <b-col cols="12">
                      <img src="../../../assets/images/zonahorariamexico.jpg" class="mb-4" alt="Zona horarias México" />
                      <div class="row">
                        <b-list-group>
                          <b-list-group-item style="background-color: #9dd1f8;
                            font-weight: bold">
                            {{ $t("configDispositivos.zonaNoroeste") }}
                          </b-list-group-item>
                          <b-list-group-item>Baja California</b-list-group-item>
                        </b-list-group>
                        <b-list-group>
                          <b-list-group-item style="background-color: #e2cea7;
                            font-weight: bold">
                            {{ $t("configDispositivos.zonaPacifico") }}
                          </b-list-group-item>
                          <b-list-group-item>Baja California Sur</b-list-group-item>
                          <b-list-group-item>Chihuahua</b-list-group-item>
                          <b-list-group-item>Nayarit</b-list-group-item>
                          <b-list-group-item>Sinaloa</b-list-group-item>
                          <b-list-group-item>Sonora</b-list-group-item>
                        </b-list-group>
                        <b-list-group>
                          <b-list-group-item style="background-color: #9dd06b;
                            font-weight: bold">
                            {{ $t("configDispositivos.zonaSureste") }}
                          </b-list-group-item>
                          <b-list-group-item>Quintana Roo</b-list-group-item>
                        </b-list-group>
                      </div>
                      <br />

                      <b-list-group>
                        <b-list-group-item class="text-light" style="background-color: #668cb1;
                          font-weight: bold">
                          {{ $t("configDispositivos.zonaCentro") }}
                        </b-list-group-item>
                      </b-list-group>
                      <div class="row">
                        <b-col cols="6">
                          <b-list-group>
                            <b-list-group-item>Aguascalientes</b-list-group-item>
                            <b-list-group-item>Campeche</b-list-group-item>
                            <b-list-group-item>Coahuila</b-list-group-item>
                            <b-list-group-item>Colima</b-list-group-item>
                            <b-list-group-item>Chiapas</b-list-group-item>
                            <b-list-group-item>Distrito Federal</b-list-group-item>
                            <b-list-group-item>Durango</b-list-group-item>
                            <b-list-group-item>Guanajuato</b-list-group-item>
                            <b-list-group-item>Guerrero</b-list-group-item>
                            <b-list-group-item>Hidalgo</b-list-group-item>
                            <b-list-group-item>Jalisco</b-list-group-item>
                            <b-list-group-item>Estado de México</b-list-group-item>
                          </b-list-group>
                        </b-col>
                        <b-col cols="6">
                          <b-list-group>
                            <b-list-group-item>Morelos</b-list-group-item>
                            <b-list-group-item>Nuevo León</b-list-group-item>
                            <b-list-group-item>Oaxaca</b-list-group-item>
                            <b-list-group-item>Puebla</b-list-group-item>
                            <b-list-group-item>Querétaro</b-list-group-item>
                            <b-list-group-item>San Luis Potosí</b-list-group-item>
                            <b-list-group-item>Tabasco</b-list-group-item>
                            <b-list-group-item>Tamaulipas</b-list-group-item>
                            <b-list-group-item>Tlaxcala</b-list-group-item>
                            <b-list-group-item>Veracruz</b-list-group-item>
                            <b-list-group-item>Yucatán</b-list-group-item>
                            <b-list-group-item>Zacatecas</b-list-group-item>
                          </b-list-group>
                        </b-col>
                      </div>
                    </b-col>

                    <b-btn class="mt-3" block @click="$bvModal.hide('bv-modal-zonaHoraria')" style="color: white">
                      {{ $t("Gral.cerrar") }}
                    </b-btn>
                  </b-modal>
                </b-col>
                <b-col cols="7" class="d-flex justify-content-center align-items-center">
                  <h5 class="mb-0" style>{{ $t("configDispositivos.modoZona") }}:</h5>
                </b-col>
                <b-col cols="2" class="d-flex justify-content-end align-items-center">
                  <b-form-checkbox v-model="select" switch size="lg">
                  </b-form-checkbox>
                </b-col>
              </div>
              <div v-if="select" class="row">
                <b-col cols="12" sm="12">
                  <b-form-group :label="$t('configDispositivos.lblZonaHor')" label-for="move">
                    <b-form-select v-model="alarma.zonaHoraria" :options="translateZonaHoraria" required style="color: black;
                      background-color: white">
                    </b-form-select>
                  </b-form-group>
                </b-col>
              </div>
            </b-card>
          </b-col>

          <!-- INICIO BATERIA BAJA-->
          <b-col class="col-12 col-sm-12 col-sm-4 col-md-6 col-lg-4">
            <b-card class="justify-content-center layered box" bg-variant="light" text-variant="black" align="center"
              header-bg-variant="dark">
              <div class="row">
                <b-col cols="3" class="d-flex justify-content-start align-items-center">
                  <b-btn
                    class="d-flex align-items-center justify-content-center rounded-circle btn btn-info text-light rounded-circle layered2 box2 ancho-icono-boton"
                    @click="$bvModal.show('bv-modal-bateria')" variant="info" v-b-tooltip.hover
                    :title="$t('configDispositivos.msgBateriaBaja', {})">
                    <em class="fas fa-question"></em>
                  </b-btn>
                  <b-modal body-bg-variant="modal" header-bg-variant="modal" id="bv-modal-bateria"
                    :title="$t('configDispositivos.bateriaBaja')" hide-footer>
                    <p class="my-4">
                      {{ $t("configDispositivos.msgBateriaBaja", { 0: $t("configDispositivos.msgCasoTK"), }) }}
                    </p>
                    <b-btn class="mt-3" block @click="$bvModal.hide('bv-modal-bateria')" style="color: white">
                      {{ $t("Gral.cerrar") }}
                    </b-btn>
                  </b-modal>
                </b-col>
                <b-col cols="7" class="d-flex justify-content-center align-items-center">
                  <h5 class="mb-0" style>{{ $t("configDispositivos.bateriaBaja") }}:</h5>
                </b-col>
                <b-col cols="2" class="d-flex justify-content-end align-items-center">
                  <b-form-checkbox disabled v-model="alarma.bateriaBaja" switch size="lg">
                  </b-form-checkbox>
                </b-col>
              </div>
            </b-card>
          </b-col>

          <!-- INICIO MODO RASTREO MICROFONO/RASTREADOR -->
          <b-col class="col-12 col-sm-12 col-sm-4 col-md-6 col-lg-4">
            <b-card class="justify-content-center layered box" bg-variant="light" text-variant="black" align="center"
              header-bg-variant="dark">
              <div class="row">
                <b-col cols="3">
                  <b-btn
                    class="d-flex align-items-center justify-content-center rounded-circle btn btn-info text-light rounded-circle layered2 box2 ancho-icono-boton"
                    @click="$bvModal.show('bv-modal-rastreo')" v-b-tooltip.hover
                    :title="$t('configDispositivos.msgHeadMicroTK')">
                    <em class="fas fa-question"></em>
                  </b-btn>
                  <b-modal body-bg-variant="modal" header-bg-variant="modal" id="bv-modal-rastreo"
                    :title="$t('configDispositivos.msgModalMicro')" hide-footer>
                    <p class="my-4" v-html="this.$t('configDispositivos.msgRastreoTK')"></p>
                    <b-form-checkbox v-model="bant" switch size="lg" disabled>
                    </b-form-checkbox>
                    <p class="my-4">{{ this.$t("configDispositivos.msgCasoTK") }}</p>
                    <b-btn class="mt-3" block @click="$bvModal.hide('bv-modal-rastreo')" style="color: white">
                      {{ $t("Gral.cerrar") }}
                    </b-btn>
                  </b-modal>
                </b-col>
                <b-col cols="7">
                  <h5 class="mb-0" style>{{ $t("configDispositivos.modoRastreo") }}:</h5>
                </b-col>
                <b-col cols="2">
                  <b-form-checkbox disabled v-model="alarma.modoRastreo" switch size="lg">
                  </b-form-checkbox>
                </b-col>
              </div>
            </b-card>
          </b-col>

          <!-- INICIO ALARMA POR IMPACTO -->
          <b-col class="col-12 col-sm-12 col-sm-4 col-md-6 col-lg-4">
            <b-card class="justify-content-center layered box" bg-variant="light" text-variant="black" align="center"
              header-bg-variant="dark">
              <div class="row">
                <b-col cols="3" class="d-flex justify-content-start align-items-center">
                  <b-btn
                    class="d-flex align-items-center justify-content-center rounded-circle btn btn-info text-light rounded-circle layered2 box2 ancho-icono-boton"
                    @click="$bvModal.show('bv-modal-impacto')" variant="info" v-b-tooltip.hover
                    :title="$t('configDispositivos.msgAlarImpact')">
                    <em class="fas fa-question"></em>
                  </b-btn>
                  <b-modal body-bg-variant="modal" header-bg-variant="modal" id="bv-modal-impacto"
                    :title="$t('configDispositivos.modoAlarma')" hide-footer>
                    <p class="my-4">{{ $t("configDispositivos.msgAlarImpact") }}</p>
                    <b-btn class="mt-3" block @click="$bvModal.hide('bv-modal-impacto')" style="color: white">
                      {{ $t("Gral.cerrar") }}
                    </b-btn>
                  </b-modal>
                </b-col>
                <b-col cols="7" class="d-flex justify-content-center align-items-center">
                  <h5 class="mb-0" style>{{ $t("configDispositivos.modoAlarma") }}:</h5>
                </b-col>
                <b-col cols="2" class="d-flex justify-content-end align-items-center">
                  <b-form-checkbox v-model="alarma.alarmaImpacto" switch size="lg">
                  </b-form-checkbox>
                </b-col>
              </div>
            </b-card>
          </b-col>

          <!-- INICIO CONFIGURACION DE SOS -->
          <b-col class="col-12 col-sm-12 col-sm-4 col-md-6 col-lg-4">
            <b-card class="justify-content-center layered box" bg-variant="light" text-variant="black" align="center"
              header-bg-variant="dark">
              <div class="row">
                <b-col cols="3" class="d-flex justify-content-start align-items-center">
                  <b-btn
                    class="d-flex align-items-center justify-content-center rounded-circle btn btn-info text-light rounded-circle layered2 box2 ancho-icono-boton"
                    @click="$bvModal.show('bv-modal-admin')" v-b-tooltip.hover
                    :title="this.$t('configDispositivos.msgConfigSOS')">
                    <em class="fas fa-question"></em>
                  </b-btn>
                  <b-modal body-bg-variant="modal" header-bg-variant="modal" id="bv-modal-admin"
                    :title="this.$t('configDispositivos.msgModalAdmin')" hide-footer>
                    <p class="my-4" v-html="this.$t('configDispositivos.msgSOS')"></p>
                    <b-btn class="mt-3" block @click="$bvModal.hide('bv-modal-admin')" style="color: white">
                      {{ $t("Gral.cerrar") }}
                    </b-btn>
                  </b-modal>
                </b-col>
                <b-col cols="7" class="d-flex justify-content-center align-items-center">
                  <h5 class="mb-0" style>{{ this.$t("configDispositivos.lblSOS") }}:</h5>
                </b-col>
                <b-col cols="2" class="d-flex justify-content-end align-items-center">
                  <b-form-checkbox v-model="alarma.banAdmin" switch size="lg">
                  </b-form-checkbox>
                </b-col>
              </div>
              <div v-if="alarma.banAdmin" class="row">
                <b-col cols="12" sm="12">
                  <div v-if="mensajeError != ''">
                    <b-alert show variant="danger">{{ mensajeError }}</b-alert>
                  </div>
                  <div class="row">
                    <b-col cols="12" sm="12">
                      <label for="“telefono”">{{ $t("Gral.tel") }}</label>
                      <b-form-input id="intervalos3" v-model="alarma.listaAdmin" class="form-input-border" required
                        :state="phoneState" style="color: black; background-color: white"
                        aria-describedby="input-live-help-telefono input-live-feedback-telefono" autocomplete="off">
                      </b-form-input>
                      <b-form-invalid-feedback id="input-live-feedback-telefono">
                        {{ $t("Gral.valExitTelefono") }}
                      </b-form-invalid-feedback>
                    </b-col>
                  </div>
                </b-col>
              </div>
            </b-card>
          </b-col>

          <!-- INICIO ESTATUS DEL DISPOSITIVO -->
          <b-col class="col-12 col-sm-12 col-sm-4 col-md-6 col-lg-4">
            <b-card class="justify-content-center layered box" bg-variant="light" text-variant="black" align="center"
              header-bg-variant="dark">
              <div class="row">
                <b-col cols="3" class="d-flex justify-content-start align-items-center">
                  <b-btn
                    class="d-flex align-items-center justify-content-center rounded-circle btn btn-info text-light rounded-circle layered2 box2 ancho-icono-boton"
                    @click="$bvModal.show('bv-modal-estatus')" v-b-tooltip.hover
                    :title="$t('configDispositivos.msgModalEstatus')">
                    <em class="fas fa-question"></em>
                  </b-btn>
                  <b-modal body-bg-variant="modal" header-bg-variant="modal" id="bv-modal-estatus"
                    :title="$t('configDispositivos.modoEstatus')" hide-footer>
                    <p class="my-4" v-html="$t('configDispositivos.msgTextEstatus')"></p>
                    <b-btn class="mt-3" block @click="$bvModal.hide('bv-modal-estatus')" style="color: white">
                      {{ $t("Gral.cerrar") }}
                    </b-btn>
                  </b-modal>
                </b-col>
                <b-col cols="7" class="d-flex justify-content-center align-items-center">
                  <h5 class="mb-0" style> {{ $t("configDispositivos.modoEstatus") }}:</h5>
                </b-col>
                <b-col cols="2" class="d-flex justify-content-end align-items-center">
                  <b-form-checkbox v-model="alarma.switchCheck" switch size="lg">
                  </b-form-checkbox>
                </b-col>
              </div>
              <div v-if="alarma.switchCheck" class="row">
                <b-col cols="12" sm="12">
                  <b-form-textarea class="form-textarea" id="textarea" :placeholder="$t('Gral.respuesta')"
                    style="color: black; background-color: white" disabled rows="8" max-rows="6">
                  </b-form-textarea>
                </b-col>
                <b-col class="col-12 col-sm-12">
                  <b-btn color="primary" variant="info" class="w-100 text-white" id="check" @click="enviarCheck">
                    {{ $t("Gral.enviar") }}
                  </b-btn>
                </b-col>
              </div>
            </b-card>
          </b-col>
        </div>
        <div class="row">
          <div class="col-12 col-sm-12 col-md-4 col-lg-4 col-xl-4 d-lg-flex justify-content-lg-end">
            <b-btn color="primary" class="mt-2 ancho-boton w-100" style="color: white" id="cancelarConfiguracion"
              @click="cancelarConfiguracion">
              {{ $t("Gral.cancelar") }}
            </b-btn>
          </div>
          <div class="col-12 col-sm-12 col-md-4 col-lg-4 col-xl-4 d-lg-flex justify-content-lg-center margin-top-div">
            <b-btn variant="info" type="submit" class="mt-2 ancho-boton text-light w-100" style="color: white"
              id="guardarMarcador">
              {{ $t("Gral.guardar") }}
            </b-btn>
          </div>
          <div class="col-12 col-sm-12 col-md-4 col-lg-4 col-xl-4 d-lg-flex margin-top-div">
            <b-btn variant="danger" class="mt-2 ancho-boton w-100 text-white" @click="begin()">
              {{ $t("vMonitoreo.msgReset") }}
            </b-btn>
          </div>
        </div>
      </b-form>
    </b-card>
  </b-col>
</template>

<script src="js/main.js"></script>
<script>
import { mapState } from "vuex";
import AlertasDataService from "../../../services/AlertasDataService";
import AlarmaSMSDataService from "../../../services/AlarmaSMSDataService";
import AccionesDataService from "../../../services/AccionesDataService";
import Jwt from "../../../services/Jwt";

export default {
  name: "configuracion",
  data() {
    return {
      // alertas: [{
      //     text: "Seleccione un tipo de apagado",
      //     value: null
      // },
      //     "No apagado",
      //     "Apagado por el sensor de impacto",
      //     "Dormir por tiempo"
      // ],
      alertas: [
        {
          //Realizar pruebas para verificas que los nombres traducidos no interfieran con los comando enviados a los dispositivos.
          text: "msgSelecApagado",
          value: null,
        },
        {
          text: "noApagado",
        },
        {
          text: "apagadoImp",
        },
        {
          text: "dormirTiempo",
        },
      ],
      // zonasHorarias: [{
      //     text: "Seleccione una zona horaria",
      //     value: null
      // },
      //     , "-5 (Zona Sureste)",
      //     "-6 (Zona Centro)",
      //     "-7 (Zona Pacífico)",
      //     "-8 (Zona Noroeste)",
      // ],
      zonasHorarias: [
        {
          //Realizar pruebas para verificas que los nombres traducidos no interfieran con los comando enviados a los dispositivos.
          text: "lblZonaHoraria",
          value: null,
        },
        {
          text: "zonaSureste",
        },
        {
          text: "zonaCentro",
        },
        {
          text: "zonaPacifico",
        },
        {
          text: "zonaNoroeste",
        },
      ],
      select: false,
      alertasTodas: this.obtenerAlertas(),
      alarma: {
        id: 0,
        idDispositivo: null,
        alarmaImpacto: false,
        apagadoProfundo: null,
        modoRastreo: true, //el modo rastreo/microfono es indistinto en los dispositivos tkstar
        bateriaBaja: true, //por default, la alarma de bateria baja viene activada
        alarmaVelocidad: false,
        velocidad: 0,
        alarmaMovimiento: false,
        radio: 0,
        dormirTiempo: false,
        tiempoDormir: null,
        alarmaApagado: false,
        tipoApagado: null,
        zonaHoraria: null,
        banAdmin: false,
        listaAdmin: "",
        switchCheck: false,
      },
      dispositivo: {
        id: 0,
        nombre: "",
        imei: "",
        modelo: "",
        model: null,
        telefono: "",
        contrasena: "",
        habilitado: false,
      },
      configuraciones: null,
      banderaRegistrado: false,
      configuracionActual: null,
      tiempoN: null,
      listaComandos: [],
      p: 0,
      mensajeError: "",
      socketban: sessionStorage.socket,
      banf: false,
      bant: true,
      accion: "",
      usuarioLogueado: JSON.parse(sessionStorage.getItem("usuarioLogueado")),
      listaMensajes: [],
    };
  },
  computed: {
    ...mapState(["locale"]),
    translateAlertas() {
      return this.translateOptions(this.alertas);
    },
    translateZonaHoraria() {
      return this.translateOptions(this.zonasHorarias);
    },
    phoneState() {
      return this.alarma.listaAdmin.match("^\\d{10}$") ? true : false;
    },
  },
  mounted() {
    this.mostrarDatos(this.$route.params);
    this.ObtenerDatos();
    this.$nextTick(() => {
      if (sessionStorage.banConfig == "false") {
        sessionStorage.setItem("banConfig", "true");
        const io = require("socket.io-client"),
          ioClient = io.connect(process.env.VUE_APP_URL_SERVER_SOCKET_ARDUINO);
        ioClient.on("sms", (msg) => {
          var trama = Jwt.jwtDecodeSms(msg);
          var num = "",
            b,
            shock;
          for (var i = 0; i < trama.length; i++) {
            if (trama.substring(i, i + 1) == "|") {
              b = i;
            }
          }
          num = trama.substring(0, b - 1);
          shock = trama.substring(b + 1, trama.length);

          if (
            num == this.dispositivo.telefono &&
            (trama.substring(b + 1, trama.length - 1) === "monitorok" ||
              trama.substring(b + 1, trama.length - 1) === "monitor ok")
          ) {
            const Toast = this.$swal.mixin({
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 5000,
              timerProgressBar: true,
              didOpen: (toast) => {
                toast.addEventListener("mouseenter", this.$swal.stopTimer);
                toast.addEventListener("mouseleave", this.$swal.resumeTimer);
              },
            });

            Toast.fire({
              icon: "success",
              text: this.$t("configDispositivos.msgMicrofono"),
            });

            var dia = new Date().toJSON().slice(0, 10).replace(/-/g, "/");
            var today = new Date();
            var time = "";
            time = today.getHours() + ":" + today.getMinutes();
            if (today.getMinutes() < 10) {
              time = today.getHours() + ":0" + today.getMinutes();
            }

            var data = {
              tipo: "Configuración",
              dispositivo: this.dispositivo,
              descripcionAlerta: this.dispositivo.nombre,
              hora: time + "HRS",
              fecha: dia,
              latitud: 0,
              longitud: 0,
              velocidad: 0.0,
              select: false,
              link: "Configuración modo micrófono",
            };

            this.guardarAlarma(data);
          }

          if (
            num == this.dispositivo.telefono &&
            (trama.substring(b + 1, trama.length - 1) === "trackerok" ||
              trama.substring(b + 1, trama.length - 1) === "tracker ok")
          ) {
            const Toast = this.$swal.mixin({
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 5000,
              timerProgressBar: true,
              didOpen: (toast) => {
                toast.addEventListener("mouseenter", this.$swal.stopTimer);
                toast.addEventListener("mouseleave", this.$swal.resumeTimer);
              },
            });

            Toast.fire({
              icon: "success",
              text: this.$t("configDispositivos.msgRastreo"),
            });

            var dia = new Date().toJSON().slice(0, 10).replace(/-/g, "/");
            var today = new Date();
            var time = "";
            time = today.getHours() + ":" + today.getMinutes();
            if (today.getMinutes() < 10) {
              time = today.getHours() + ":0" + today.getMinutes();
            }

            var data = {
              tipo: "Configuración",
              dispositivo: this.dispositivo,
              descripcionAlerta: this.dispositivo.nombre,
              hora: time + "HRS",
              fecha: dia,
              latitud: 0,
              longitud: 0,
              velocidad: 0.0,
              select: false,
              link: "Modo rastreo",
            };

            this.guardarAlarma(data);
          }

          if (
            num == this.dispositivo.telefono &&
            (trama.substring(b + 1, trama.length - 1) === "sosnumberok" ||
              trama.substring(b + 1, trama.length - 1) === "sos number ok")
          ) {
            const Toast = this.$swal.mixin({
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 5000,
              timerProgressBar: true,
              didOpen: (toast) => {
                toast.addEventListener("mouseenter", this.$swal.stopTimer);
                toast.addEventListener("mouseleave", this.$swal.resumeTimer);
              },
            });

            Toast.fire({
              icon: "success",
              text: this.$t("configDispositivos.msgSOSAgregado"),
            });
            var dia = new Date().toJSON().slice(0, 10).replace(/-/g, "/");
            var today = new Date();
            var time = "";
            time = today.getHours() + ":" + today.getMinutes();
            if (today.getMinutes() < 10) {
              time = today.getHours() + ":0" + today.getMinutes();
            }

            var data = {
              tipo: "Configuración",
              dispositivo: this.dispositivo,
              descripcionAlerta: this.dispositivo.nombre,
              hora: time + "HRS",
              fecha: dia,
              latitud: 0,
              longitud: 0,
              velocidad: 0.0,
              select: false,
              link: "SOS agregado",
            };

            this.guardarAlarma(data);
          }

          if (
            num == this.dispositivo.telefono &&
            (trama.substring(b + 1, trama.length - 1) === "nososnumberok" ||
              trama.substring(b + 1, trama.length - 1) === "nosos number ok")
          ) {
            const Toast = this.$swal.mixin({
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 5000,
              timerProgressBar: true,
              didOpen: (toast) => {
                toast.addEventListener("mouseenter", this.$swal.stopTimer);
                toast.addEventListener("mouseleave", this.$swal.resumeTimer);
              },
            });

            Toast.fire({
              icon: "success",
              text: this.$t("configDispositivos.msgSOSDel"),
            });
            var dia = new Date().toJSON().slice(0, 10).replace(/-/g, "/");
            var today = new Date();
            var time = "";
            time = today.getHours() + ":" + today.getMinutes();
            if (today.getMinutes() < 10) {
              time = today.getHours() + ":0" + today.getMinutes();
            }

            var data = {
              tipo: "Configuración",
              dispositivo: this.dispositivo,
              descripcionAlerta: this.dispositivo.nombre,
              hora: time + "HRS",
              fecha: dia,
              latitud: 0,
              longitud: 0,
              velocidad: 0.0,
              select: false,
              link: "SOS eliminado",
            };

            this.guardarAlarma(data);
          }
          if (
            num == this.dispositivo.telefono &&
            (trama.substring(b + 1, trama.length - 1) === "shockok" ||
              trama.substring(b + 1, trama.length - 1) === "shock ok")
          ) {
            const Toast = this.$swal.mixin({
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 5000,
              timerProgressBar: true,
              didOpen: (toast) => {
                toast.addEventListener("mouseenter", this.$swal.stopTimer);
                toast.addEventListener("mouseleave", this.$swal.resumeTimer);
              },
            });

            Toast.fire({
              icon: "success",
              text: this.$t("configDispositivos.msgAlerta"),
            });

            var dia = new Date().toJSON().slice(0, 10).replace(/-/g, "/");
            var today = new Date();
            var time = "";
            time = today.getHours() + ":" + today.getMinutes();
            if (today.getMinutes() < 10) {
              time = today.getHours() + ":0" + today.getMinutes();
            }

            var data = {
              tipo: "Configuración",
              dispositivo: this.dispositivo,
              descripcionAlerta: this.dispositivo.nombre,
              hora: time + "HRS",
              fecha: dia,
              latitud: 0,
              longitud: 0,
              velocidad: 0.0,
              select: false,
              link: "Alerta impacto",
            };

            this.guardarAlarma(data);
          }

          if (
            num == this.dispositivo.telefono &&
            (trama.substring(b + 1, trama.length - 1) === "noshockok" ||
              trama.substring(b + 1, trama.length - 1) === "noshock ok")
          ) {
            const Toast = this.$swal.mixin({
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 5000,
              timerProgressBar: true,
              didOpen: (toast) => {
                toast.addEventListener("mouseenter", this.$swal.stopTimer);
                toast.addEventListener("mouseleave", this.$swal.resumeTimer);
              },
            });

            Toast.fire({
              icon: "success",
              text: this.$t("configDispositivos.msgAlertaDes"),
            });

            var dia = new Date().toJSON().slice(0, 10).replace(/-/g, "/");
            var today = new Date();
            var time = "";
            time = today.getHours() + ":" + today.getMinutes();
            if (today.getMinutes() < 10) {
              time = today.getHours() + ":0" + today.getMinutes();
            }

            var data = {
              tipo: "Configuración",
              dispositivo: this.dispositivo,
              descripcionAlerta: this.dispositivo.nombre,
              hora: time + "HRS",
              fecha: dia,
              latitud: 0,
              longitud: 0,
              velocidad: 0.0,
              select: false,
              link: "Alarma impacto desactivada",
            };

            this.guardarAlarma(data);
          }
          if (
            num == this.dispositivo.telefono &&
            (trama.substring(b + 1, trama.length - 1) === "speedok" ||
              trama.substring(b + 1, trama.length - 1) === "speed ok")
          ) {
            const Toast = this.$swal.mixin({
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 5000,
              timerProgressBar: true,
              didOpen: (toast) => {
                toast.addEventListener("mouseenter", this.$swal.stopTimer);
                toast.addEventListener("mouseleave", this.$swal.resumeTimer);
              },
            });

            Toast.fire({
              icon: "success",
              text: this.$t("configDispositivos.msgVelocidad"),
            });

            var dia = new Date().toJSON().slice(0, 10).replace(/-/g, "/");
            var today = new Date();
            var time = "";
            time = today.getHours() + ":" + today.getMinutes();
            if (today.getMinutes() < 10) {
              time = today.getHours() + ":0" + today.getMinutes();
            }

            var data = {
              tipo: "Configuración",
              dispositivo: this.dispositivo,
              descripcionAlerta: this.dispositivo.nombre,
              hora: time + "HRS",
              fecha: dia,
              latitud: 0,
              longitud: 0,
              velocidad: 0.0,
              select: false,
              link: "Alarma velocidad activada",
            };

            this.guardarAlarma(data);
          }

          if (
            num == this.dispositivo.telefono &&
            (trama.substring(b + 1, trama.length - 1) === "nospeedok" ||
              trama.substring(b + 1, trama.length - 1) === "nospeed ok")
          ) {
            const Toast = this.$swal.mixin({
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 5000,
              timerProgressBar: true,
              didOpen: (toast) => {
                toast.addEventListener("mouseenter", this.$swal.stopTimer);
                toast.addEventListener("mouseleave", this.$swal.resumeTimer);
              },
            });

            Toast.fire({
              icon: "success",
              text: this.$t("configDispositivos.msgVelocidadDes"),
            });

            var dia = new Date().toJSON().slice(0, 10).replace(/-/g, "/");
            var today = new Date();
            var time = "";
            time = today.getHours() + ":" + today.getMinutes();
            if (today.getMinutes() < 10) {
              time = today.getHours() + ":0" + today.getMinutes();
            }

            var data = {
              tipo: "Configuración",
              dispositivo: this.dispositivo,
              descripcionAlerta: this.dispositivo.nombre,
              hora: time + "HRS",
              fecha: dia,
              latitud: 0,
              longitud: 0,
              velocidad: 0.0,
              select: false,
              link: "Alarma velocidad desactivada",
            };
            this.guardarAlarma(data);
          }
          if (
            num == this.dispositivo.telefono &&
            (trama.substring(b + 1, trama.length - 1) === "moveok" ||
              trama.substring(b + 1, trama.length - 1) === "move ok")
          ) {
            const Toast = this.$swal.mixin({
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 5000,
              timerProgressBar: true,
              didOpen: (toast) => {
                toast.addEventListener("mouseenter", this.$swal.stopTimer);
                toast.addEventListener("mouseleave", this.$swal.resumeTimer);
              },
            });

            Toast.fire({
              icon: "success",
              text: this.$t("configDispositivos.msgMovimiento"),
            });

            var dia = new Date().toJSON().slice(0, 10).replace(/-/g, "/");
            var today = new Date();
            var time = "";
            time = today.getHours() + ":" + today.getMinutes();
            if (today.getMinutes() < 10) {
              time = today.getHours() + ":0" + today.getMinutes();
            }

            var data = {
              tipo: "Configuración",
              dispositivo: this.dispositivo,
              descripcionAlerta: this.dispositivo.nombre,
              hora: time + "HRS",
              fecha: dia,
              latitud: 0,
              longitud: 0,
              velocidad: 0.0,
              select: false,
              link: "Alarma movimiento activada",
            };
            this.guardarAlarma(data);
          }
          if (
            num == this.dispositivo.telefono &&
            (trama.substring(b + 1, trama.length - 1) === "nomoveok" ||
              trama.substring(b + 1, trama.length - 1) === "nomove ok")
          ) {
            const Toast = this.$swal.mixin({
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 5000,
              timerProgressBar: true,
              didOpen: (toast) => {
                toast.addEventListener("mouseenter", this.$swal.stopTimer);
                toast.addEventListener("mouseleave", this.$swal.resumeTimer);
              },
            });

            Toast.fire({
              icon: "success",
              text: this.$t("configDispositivos.msgMovimientoDes"),
            });

            var dia = new Date().toJSON().slice(0, 10).replace(/-/g, "/");
            var today = new Date();
            var time = "";
            time = today.getHours() + ":" + today.getMinutes();
            if (today.getMinutes() < 10) {
              time = today.getHours() + ":0" + today.getMinutes();
            }

            var data = {
              tipo: "Configuración",
              dispositivo: this.dispositivo,
              descripcionAlerta: this.dispositivo.nombre,
              hora: time + "HRS",
              fecha: dia,
              latitud: 0,
              longitud: 0,
              velocidad: 0.0,
              select: false,
              link: "Alarma movimiento desactivada",
            };
            this.guardarAlarma(data);
          }
          if (
            num == this.dispositivo.telefono &&
            (trama.substring(b + 1, trama.length - 1) == "beginok" ||
              trama.substring(b + 1, trama.length - 1) == "begin ok")
          ) {
            var dia = new Date().toJSON().slice(0, 10).replace(/-/g, "/");
            var today = new Date();
            var time = "";
            time = today.getHours() + ":" + today.getMinutes();
            if (today.getMinutes() < 10) {
              time = today.getHours() + ":0" + today.getMinutes();
            }
            var data = {
              tipo: "Configuración",
              dispositivo: this.dispositivo,
              descripcionAlerta: this.dispositivo.nombre,
              hora: time + "HRS",
              fecha: dia,
              latitud: 0,
              longitud: 0,
              velocidad: 0.0,
              select: false,
              link: "Reinicio de fábrica",
            };
            this.guardarAlarma(data);
            var data = {
              id: this.alarma.id,
              idDispositivo: this.configuracionActual.idDispositivo,
              alarmaImpacto: false,
              apagadoProfundo: null,
              alarmaVelocidad: false,
              velocidad: 0,
              alarmaMovimiento: false,
              radio: 0,
              dormirTiempo: false,
              tiempoDormir: null,
              alarmaApagado: false,
              tipoApagado: null,
              zonaHoraria: null,
              banAdmin: false,
              switchCheck: false,
            };
            sessionStorage.setItem("idAlarmaSMS", this.alarma.id);
            AlarmaSMSDataService.update(data)
              .then(() => {
                const Toast2 = this.$swal.mixin({
                  toast: true,
                  position: "top-end",
                  showConfirmButton: false,
                  timer: 4000,
                  timerProgressBar: true,
                  didOpen: (toast) => {
                    toast.addEventListener("mouseenter", this.$swal.stopTimer);
                    toast.addEventListener(
                      "mouseleave",
                      this.$swal.resumeTimer
                    );
                  },
                });
                Toast2.fire({
                  icon: "success",
                  title: this.$t("vMonitoreo.msgReset"),
                  text: this.$t("configDispositivos.msgReinicio"),
                });
                this.ObtenerDatos();
              })
              .catch(() => {
                const Toast = this.$swal.mixin({
                  toast: true,
                  position: "top-end",
                  showConfirmButton: false,
                  timer: 4000,
                  timerProgressBar: true,
                  didOpen: (toast) => {
                    toast.addEventListener("mouseenter", this.$swal.stopTimer);
                    toast.addEventListener(
                      "mouseleave",
                      this.$swal.resumeTimer
                    );
                  },
                });

                Toast.fire({
                  icon: "error",
                  title: this.$t("configDispositivos.msgErrActConfig"),
                });
              });
          }
          if (
            num == this.dispositivo.telefono &&
            (trama.substring(b + 1, trama.length - 1) === "sleep time ok" ||
              trama.substring(b + 1, trama.length - 1) === "sleeptime ok")
          ) {
            const Toast = this.$swal.mixin({
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 5000,
              timerProgressBar: true,
              didOpen: (toast) => {
                toast.addEventListener("mouseenter", this.$swal.stopTimer);
                toast.addEventListener("mouseleave", this.$swal.resumeTimer);
              },
            });

            Toast.fire({
              icon: "success",
              text: this.$t("configDispositivos.dormirTiempo"),
            });

            var dia = new Date().toJSON().slice(0, 10).replace(/-/g, "/");
            var today = new Date();
            var time = "";
            time = today.getHours() + ":" + today.getMinutes();
            if (today.getMinutes() < 10) {
              time = today.getHours() + ":0" + today.getMinutes();
            }

            var data = {
              tipo: "Configuración",
              dispositivo: this.dispositivo,
              descripcionAlerta: this.dispositivo.nombre,
              hora: time + "HRS",
              fecha: dia,
              latitud: 0,
              longitud: 0,
              velocidad: 0.0,
              select: false,
              link: "Dormir por tiempo",
            };
            this.guardarAlarma(data);
          }
          if (
            num == this.dispositivo.telefono &&
            (trama.substring(b + 1, trama.length - 1) === "sleepshock ok" ||
              trama.substring(b + 1, trama.length - 1) === "sleep shock ok")
          ) {
            const Toast = this.$swal.mixin({
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 5000,
              timerProgressBar: true,
              didOpen: (toast) => {
                toast.addEventListener("mouseenter", this.$swal.stopTimer);
                toast.addEventListener("mouseleave", this.$swal.resumeTimer);
              },
            });

            Toast.fire({
              icon: "success",
              text: this.$t("configDispositivos.apagadoImp"),
            });

            var dia = new Date().toJSON().slice(0, 10).replace(/-/g, "/");
            var today = new Date();
            var time = "";
            time = today.getHours() + ":" + today.getMinutes();
            if (today.getMinutes() < 10) {
              time = today.getHours() + ":0" + today.getMinutes();
            }

            var data = {
              tipo: "Configuración",
              dispositivo: this.dispositivo,
              descripcionAlerta: this.dispositivo.nombre,
              hora: time + "HRS",
              fecha: dia,
              latitud: 0,
              longitud: 0,
              velocidad: 0.0,
              select: false,
              link: "Apagado por el sensor de impacto",
            };
            this.guardarAlarma(data);
          }
          if (
            num == this.dispositivo.telefono &&
            (trama.substring(b + 1, trama.length - 1) === "sleepoff ok" ||
              trama.substring(b + 1, trama.length - 1) === "sleep off ok")
          ) {
            const Toast = this.$swal.mixin({
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 5000,
              timerProgressBar: true,
              didOpen: (toast) => {
                toast.addEventListener("mouseenter", this.$swal.stopTimer);
                toast.addEventListener("mouseleave", this.$swal.resumeTimer);
              },
            });

            Toast.fire({
              icon: "success",
              text: this.$t("configDispositivos.msgApagEnc"),
            });

            var dia = new Date().toJSON().slice(0, 10).replace(/-/g, "/");
            var today = new Date();
            var time = "";
            time = today.getHours() + ":" + today.getMinutes();
            if (today.getMinutes() < 10) {
              time = today.getHours() + ":0" + today.getMinutes();
            }

            var data = {
              tipo: "Configuración",
              dispositivo: this.dispositivo,
              descripcionAlerta: this.dispositivo.nombre,
              hora: time + "HRS",
              fecha: dia,
              latitud: 0,
              longitud: 0,
              velocidad: 0.0,
              select: false,
              link: "No apagado/Encendido",
            };
            this.guardarAlarma(data);
          }
          if (
            num == this.dispositivo.telefono &&
            (trama.substring(b + 1, trama.length - 1) === "timeok" ||
              trama.substring(b + 1, trama.length - 1) === "time ok")
          ) {
            const Toast = this.$swal.mixin({
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 5000,
              timerProgressBar: true,
              didOpen: (toast) => {
                toast.addEventListener("mouseenter", this.$swal.stopTimer);
                toast.addEventListener("mouseleave", this.$swal.resumeTimer);
              },
            });

            Toast.fire({
              icon: "success",
              text: this.$t("configDispositivos.modoZona"),
            });

            var dia = new Date().toJSON().slice(0, 10).replace(/-/g, "/");
            var today = new Date();
            var time = "";
            time = today.getHours() + ":" + today.getMinutes();
            if (today.getMinutes() < 10) {
              time = today.getHours() + ":0" + today.getMinutes();
            }

            var data = {
              tipo: "Configuración",
              dispositivo: this.dispositivo,
              descripcionAlerta: this.dispositivo.nombre,
              hora: time + "HRS",
              fecha: dia,
              latitud: 0,
              longitud: 0,
              velocidad: 0.0,
              select: false,
              link: "Configuración zona horaria y fecha",
            };
            this.guardarAlarma(data);
          }
        });
      }
    });
  },
  methods: {
    translateOptions(values) {
      return values.map((option) => {
        if (typeof option === "object" && option.text) {
          return {
            ...option,
            text: this.$t(`configDispositivos.${option.text}`),
          };
        }
      });
    },
    getModelo() {
      if (this.dispositivo.model) return this.dispositivo.model.modelo;
      else return this.$t("configDispositivos.noAsignado");
    },
    mostrarDatos(datos) {
      this.dispositivo.id = datos.id;
      this.dispositivo.nombre = datos.nombre;
      this.dispositivo.imei = datos.imei;
      this.dispositivo.modelo = datos.modelo;
      this.dispositivo.model = datos.model;
      this.dispositivo.telefono = datos.telefono;
      this.dispositivo.habilitado = datos.habilitado;
      this.dispositivo.contrasena = datos.contrasena;
    },
    /**
     * Método que obtiene todas las configuraciones registradas en sistema y verifica si alguna de ellas corresponde al dispositivo actual
     */
    ObtenerDatos() {
      AlarmaSMSDataService.getAll()
        .then((response) => {
          this.configuraciones = Jwt.jwtDecode(response.data);
          if (!this.configuraciones.length == 0) {
            for (var i in this.configuraciones) {
              if (
                this.configuraciones[i].idDispositivo == this.dispositivo.id
              ) {
                this.configuracionActual = this.configuraciones[i];
                this.banderaRegistrado = true;
                this.alarma.id = this.configuraciones[i].id;
                this.alarma.idDispositivo =
                  this.configuraciones[i].idDispositivo;
                this.alarma.alarmaImpacto =
                  this.configuraciones[i].alarmaImpacto;
                this.alarma.apagadoProfundo =
                  this.configuraciones[i].apagadoProfundo;
                this.alarma.alarmaVelocidad =
                  this.configuraciones[i].alarmaVelocidad;
                this.alarma.velocidad = this.configuraciones[i].velocidad;
                this.alarma.alarmaMovimiento =
                  this.configuraciones[i].alarmaMovimiento;
                this.alarma.radio = this.configuraciones[i].radio;
                this.alarma.dormirTiempo = this.configuraciones[i].dormirTiempo;
                this.alarma.tiempoDormir = this.configuraciones[i].tiempoDormir;
                this.alarma.alarmaApagado =
                  this.configuraciones[i].alarmaApagado;
                this.alarma.tipoApagado = this.configuraciones[i].tipoApagado;
                if (this.configuraciones[i].tipoApagado == null) {
                  this.alarma.tipoApagado = null;
                }
                this.alarma.zonaHoraria = this.configuraciones[i].zonaHoraria;
                if (this.configuraciones[i].zonaHoraria == null) {
                  this.alarma.zonaHoraria = null;
                }
                if (this.configuraciones[i].listaAdmin[0]) {
                  this.alarma.listaAdmin =
                    this.configuraciones[i].listaAdmin[0];
                }
              }
            }
            if (this.alarma.listaAdmin.length >= 10) {
              this.alarma.banAdmin = true;
            } else this.alarma.banAdmin = false;
          } else {
            this.banderaRegistrado = false;
          }
        })
        .catch((e) => {
          const s = "401";
          if (e.toString().includes(s)) {
            this.$router.push({
              path: "/",
            });
            const Toast = this.$swal.mixin({
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 4000,
              timerProgressBar: true,
              didOpen: (toast) => {
                toast.addEventListener("mouseenter", this.$swal.stopTimer);
                toast.addEventListener("mouseleave", this.$swal.resumeTimer);
              },
            });

            Toast.fire({
              icon: "warning",
              title: this.$t('Gral.msgSesion')
            });
          }
        });
    },
    obtenerAlertas() {
      AlertasDataService.getAll()
        .then((response) => {
          this.alertasTodas = Jwt.jwtDecode(response.data);
        })
        .catch((e) => {
          const s = "401";
          if (e.toString().includes(s)) {
            this.$router.push({
              path: "/",
            });
          }
        });
    },
    guardarAlarma(data) {
      AlertasDataService.create(data).then(() => {
        const Toast = this.$swal.mixin({
          toast: true,
          position: "top-end",
          showConfirmButton: false,
          timer: 4000,
          timerProgressBar: true,
          didOpen: (toast) => {
            toast.addEventListener("mouseenter", this.$swal.stopTimer);
            toast.addEventListener("mouseleave", this.$swal.resumeTimer);
          },
        });

        Toast.fire({
          icon: "success",
          title: this.$t("configDispositivos.msgRespuesta"),
        });
      });
    },
    guardarConfiguracion() {
      this.listaComandos = [];
      this.listaMensajes = [];
      this.p = 0;
      if (!this.banderaRegistrado) {
        var admin = [];
        if (this.alarma.listaAdmin)
          if (this.alarma.listaAdmin.length >= 10)
            admin.push(this.alarma.listaAdmin);
        var data = {
          idDispositivo: this.dispositivo.id,
          alarmaImpacto: this.alarma.alarmaImpacto,
          apagadoProfundo: this.alarma.apagadoProfundo,
          alarmaVelocidad: this.alarma.alarmaVelocidad,
          velocidad: this.alarma.velocidad,
          alarmaMovimiento: this.alarma.alarmaMovimiento,
          radio: this.alarma.radio,
          dormirTiempo: this.alarma.dormirTiempo,
          tiempoDormir: this.alarma.tiempoDormir,
          alarmaApagado: this.alarma.alarmaApagado,
          tipoApagado: this.alarma.tipoApagado,
          zonaHoraria: this.alarma.zonaHoraria,
          listaAdmin: admin,
        };
        if (this.alarma.banAdmin === false) {
          if (this.alarma.listaAdmin)
            this.eliminarAdmin(this.alarma.listaAdmin);
        } else {
          this.agregarAdmin();
        }
        if (this.alarma.alarmaVelocidad) {
          var velocidad = "000",
            espacio = " ";
          if (this.alarma.alarmaVelocidad) {
            if (this.alarma.velocidad < 10 || this.alarma.velocidad < 100) {
              if (this.alarma.velocidad < 10) {
                velocidad = "00" + this.alarma.velocidad;
              } else {
                velocidad = "0" + this.alarma.velocidad;
              }
            } else {
              velocidad = this.alarma.velocidad;
            }
          }
          var comando = "speed";
          this.accion =
            "Activó Velocidad para el dispositivo " +
            this.dispositivo.nombre +
            " con número " +
            this.dispositivo.telefono +
            ". Velocidad " +
            this.alarma.velocidad +
            " Km/h";
          if (!this.alarma.alarmaVelocidad) {
            comando = "nospeed";
            espacio = "";
            velocidad = "";
            this.accion =
              "Desactivó Velocidad para el dispositivo " +
              this.dispositivo.nombre +
              " con número " +
              this.dispositivo.telefono;
          }
          this.listaMensajes[this.p] = this.accion;
          var comandoFin =
            this.dispositivo.telefono +
            "," +
            comando +
            this.dispositivo.contrasena +
            espacio +
            velocidad;
          this.listaComandos[this.p] = comandoFin;
          this.p++;
        }
        if (this.alarma.alarmaMovimiento) {
          var radio = "0000";
          var espacio = " ";
          if (this.alarma.alarmaMovimiento) {
            if (this.alarma.radio < 10 || this.alarma.radio < 1000) {
              if (this.alarma.radio < 10) {
                radio = "000" + this.alarma.radio;
              } else {
                if (this.alarma.radio < 100) {
                  radio = "00" + this.alarma.radio;
                } else {
                  radio = "0" + this.alarma.radio;
                }
              }
            } else {
              radio = this.alarma.radio;
            }
          }
          var comando = "move";
          this.accion =
            "Activó Movimiento para el disposivo " +
            this.dispositivo.nombre +
            " con número " +
            this.dispositivo.telefono +
            ". Radio: " +
            radio;
          if (!this.alarma.alarmaMovimiento) {
            comando = "nomove";
            espacio = "";
            radio = "";
            this.accion =
              "Desactivó Movimiento para el disposivo " +
              this.dispositivo.nombre +
              " con número " +
              this.dispositivo.telefono;
          }
          this.listaMensajes[this.p] = this.accion;
          var comandoFin =
            this.dispositivo.telefono +
            "," +
            comando +
            this.dispositivo.contrasena +
            espacio +
            radio;
          this.listaComandos[this.p] = comandoFin;
          this.p++;
        }
        if (this.alarma.zonaHoraria) {
          var comando = "timezone";
          var espacio = " ";
          var zona = this.alarma.zonaHoraria.substring(0, 3);
          this.accion =
            "Modificó la configuración de zona horaria y fecha para el disposivo " +
            this.dispositivo.nombre +
            " con número " +
            this.dispositivo.telefono +
            ". Zona horaria " +
            this.alarma.zonaHoraria;
          this.listaMensajes[this.p] = this.accion;

          var comandoFin =
            this.dispositivo.telefono +
            "," +
            comando +
            this.dispositivo.contrasena +
            espacio +
            zona;
          this.listaComandos[this.p] = comandoFin;
          this.p++;
        }
        if (this.alarma.alarmaApagado) {
          var espacio = " ";
          var comando = "sleep";
          var comando2 = "off";
          if (this.alarma.alarmaApagado) {
            if (this.alarma.tipoApagado == "Dormir por tiempo") {
              comando2 = "time";
            }
            if (this.alarma.tipoApagado == "Apagado por el senso de impacto") {
              comando2 = "shock";
            }
          } else {
            this.alarma.tipoApagado = "No apagado";
          }
          this.accion =
            "Activó Modo stop and go para el disposivo " +
            this.dispositivo.nombre +
            " con número " +
            this.dispositivo.telefono +
            ". Tipo " +
            this.alarma.tipoApagado;
          this.listaMensajes[this.p] = this.accion;
          var comandoFin =
            this.dispositivo.telefono +
            "," +
            comando +
            this.dispositivo.contrasena +
            espacio +
            comando2;
          this.listaComandos[this.p] = comandoFin;
          this.p++;
        }
        if (this.alarma.alarmaImpacto) {
          var comando = "shock";
          var txt = "A";
          if (!this.alarma.alarmaImpacto) {
            comando = "noshock";
            txt = "Desa";
          }
          this.accion =
            txt +
            "ctivó Alarma por impacto para el disposivo " +
            this.dispositivo.nombre +
            " con número " +
            this.dispositivo.telefono;
          this.listaMensajes[this.p] = this.accion;
          var comandoFin =
            this.dispositivo.telefono +
            "," +
            comando +
            this.dispositivo.contrasena;
          this.listaComandos[this.p] = comandoFin;
          this.p++;
        }
        setTimeout(
          this.enviarComando(this.listaComandos, this.listaMensajes),
          5000
        );
        sessionStorage.setItem("idAlarmaSMS", this.alarma.id);
        AlarmaSMSDataService.create(data).then(() => {
          this.formMarcador = false;
          const Toast = this.$swal.mixin({
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 4000,
            timerProgressBar: true,
            didOpen: (toast) => {
              toast.addEventListener("mouseenter", this.$swal.stopTimer);
              toast.addEventListener("mouseleave", this.$swal.resumeTimer);
            },
          });

          Toast.fire({
            icon: "success",
            title: this.$t("configDispositivos.msgConfigExito"),
          });
          this.ObtenerDatos();
        });
      } else {
        //actualizar datos
        var admin = [];
        if (this.alarma.listaAdmin)
          if (this.alarma.listaAdmin.length >= 10)
            admin.push(this.alarma.listaAdmin);
        var data = {
          id: this.alarma.id,
          idDispositivo: this.dispositivo.id,
          alarmaImpacto: this.alarma.alarmaImpacto,
          apagadoProfundo: this.alarma.apagadoProfundo,
          alarmaVelocidad: this.alarma.alarmaVelocidad,
          velocidad: this.alarma.velocidad,
          alarmaMovimiento: this.alarma.alarmaMovimiento,
          radio: this.alarma.radio,
          alarmaApagado: this.alarma.alarmaApagado,
          tipoApagado: this.alarma.tipoApagado,
          zonaHoraria: this.alarma.zonaHoraria,
          listaAdmin: admin,
        };
        if (this.alarma.banAdmin === false) {
          if (this.alarma.listaAdmin)
            this.eliminarAdmin(this.alarma.listaAdmin);
        } else {
          this.agregarAdmin();
        }
        if (
          this.alarma.alarmaVelocidad !=
            this.configuracionActual.alarmaVelocidad ||
          this.alarma.velocidad != this.configuracionActual.velocidad
        ) {
          var velocidad = "000",
            espacio = " ";
          if (this.alarma.alarmaVelocidad) {
            if (this.alarma.velocidad < 10 || this.alarma.velocidad < 100) {
              if (this.alarma.velocidad < 10) {
                velocidad = "00" + this.alarma.velocidad;
              } else {
                velocidad = "0" + this.alarma.velocidad;
              }
            } else {
              velocidad = this.alarma.velocidad;
            }
          }
          var comando = "speed";
          this.accion =
            "Activó Velocidad para el dispositivo " +
            this.dispositivo.nombre +
            " con número " +
            this.dispositivo.telefono +
            ". Velocidad " +
            this.alarma.velocidad +
            " Km/h";
          if (!this.alarma.alarmaVelocidad) {
            comando = "nospeed";
            espacio = "";
            velocidad = "";
            this.accion =
              "Desactivó Velocidad para el dispositivo " +
              this.dispositivo.nombre +
              " con número " +
              this.dispositivo.telefono;
          }
          this.listaMensajes[this.p] = this.accion;
          var comandoFin =
            this.dispositivo.telefono +
            "," +
            comando +
            this.dispositivo.contrasena +
            espacio +
            velocidad;
          this.listaComandos[this.p] = comandoFin;
          this.p++;
        }
        if (
          this.alarma.alarmaMovimiento !=
            this.configuracionActual.alarmaMovimiento ||
          this.alarma.radio != this.configuracionActual.radio
        ) {
          var radio = "0000";
          var espacio = " ";
          if (this.alarma.alarmaMovimiento) {
            if (this.alarma.radio < 10 || this.alarma.radio < 1000) {
              if (this.alarma.radio < 10) {
                radio = "000" + this.alarma.radio;
              } else {
                if (this.alarma.radio < 100) {
                  radio = "00" + this.alarma.radio;
                } else {
                  radio = "0" + this.alarma.radio;
                }
              }
            } else {
              radio = this.alarma.radio;
            }
          }
          var comando = "move";
          this.accion =
            "Activó Movimiento para el disposivo " +
            this.dispositivo.nombre +
            " con número " +
            this.dispositivo.telefono +
            ". Radio: " +
            radio;
          if (!this.alarma.alarmaMovimiento) {
            comando = "nomove";
            espacio = "";
            radio = "";
            this.accion =
              "Desactivó Movimiento para el disposivo " +
              this.dispositivo.nombre +
              " con número " +
              this.dispositivo.telefono;
          }
          this.listaMensajes[this.p] = this.accion;
          var comandoFin =
            this.dispositivo.telefono +
            "," +
            comando +
            this.dispositivo.contrasena +
            espacio +
            radio;
          this.listaComandos[this.p] = comandoFin;
          this.p++;
        }
        if (this.alarma.zonaHoraria != this.configuracionActual.zonaHoraria) {
          var comando = "timezone";
          var espacio = " ";
          var zona = this.alarma.zonaHoraria.substring(0, 3);
          this.accion =
            "Modificó la configuración de zona horaria y fecha para el disposivo " +
            this.dispositivo.nombre +
            " con número " +
            this.dispositivo.telefono +
            ". Zona horaria " +
            this.alarma.zonaHoraria;
          this.listaMensajes[this.p] = this.accion;
          var comandoFin =
            this.dispositivo.telefono +
            "," +
            comando +
            this.dispositivo.contrasena +
            espacio +
            zona;
          this.listaComandos[this.p] = comandoFin;
          this.p++;
        }
        if (
          this.alarma.alarmaApagado != this.configuracionActual.alarmaApagado ||
          this.alarma.tipoApagado != this.configuracionActual.tipoApagado
        ) {
          //MODO STOP AND GO
          var espacio = " ";
          var comando = "sleep";
          var comando2 = "off";
          if (this.alarma.alarmaApagado) {
            if (this.alarma.tipoApagado == "Dormir por tiempo") {
              comando2 = "time";
            }
            if (this.alarma.tipoApagado == "Apagado por el sensor de impacto") {
              comando2 = "shock";
            }
          } else {
            this.alarma.tipoApagado = "No apagado";
          }
          this.accion =
            "Activó Modo stop and go para el disposivo " +
            this.dispositivo.nombre +
            " con número " +
            this.dispositivo.telefono +
            ". Tipo " +
            this.alarma.tipoApagado;
          this.listaMensajes[this.p] = this.accion;
          var comandoFin =
            this.dispositivo.telefono +
            "," +
            comando +
            this.dispositivo.contrasena +
            espacio +
            comando2;
          this.listaComandos[this.p] = comandoFin;
          this.p++;
        }
        if (
          this.alarma.alarmaImpacto != this.configuracionActual.alarmaImpacto
        ) {
          var comando = "shock";
          var txt = "A";
          if (!this.alarma.alarmaImpacto) {
            comando = "noshock";
            txt = "Desa";
          }
          this.accion =
            txt +
            "ctivó Alarma por impacto para el disposivo " +
            this.dispositivo.nombre +
            " con número " +
            this.dispositivo.telefono;
          this.listaMensajes[this.p] = this.accion;
          var comandoFin =
            this.dispositivo.telefono +
            "," +
            comando +
            this.dispositivo.contrasena;
          this.listaComandos[this.p] = comandoFin;
          this.p++;
        }

        if (this.listaComandos != []) {
          var ban = this.listaComandos % 2;
          for (var i = 0; i < this.listaComandos.length; i++) {
            var listaComandos = [];
            var listaMensajes = [];
            if ((ban = 1)) {
              listaComandos[0] = this.listaComandos[i];
              listaMensajes[0] = this.listaMensajes[i];
              ban = 0;
            } else {
              listaComandos[0] = this.listaComandos[i];
              listaComandos[1] = this.listaComandos[i + 1];
              listaMensajes[0] = this.listaMensajes[i];
              listaMensajes[1] = this.listaMensajes[i + 1];
              i++;
            }
            this.enviarComando(listaComandos, listaMensajes);
          }
        }
        sessionStorage.setItem("idAlarmaSMS", this.alarma.id);

        AlarmaSMSDataService.update(data)
          .then(() => {
            this.formMarcador = false;
            const Toast = this.$swal.mixin({
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 4000,
              timerProgressBar: true,
              didOpen: (toast) => {
                toast.addEventListener("mouseenter", this.$swal.stopTimer);
                toast.addEventListener("mouseleave", this.$swal.resumeTimer);
              },
            });

            Toast.fire({
              icon: "success",
              title: this.$t("configDispositivos.msgConfigExito"),
            });
            this.ObtenerDatos();
          })
          .catch(() => {});
      }
      this.ObtenerDatos();
    },
    cancelarConfiguracion() {
      this.$router.push({
        path: "/monitoreo",
      });
    },
    begin() {
      this.$swal({
        text: this.$t("vMonitoreo.msgConfiReset"),
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "gray",
        confirmButtonText: this.$t("Gral.aceptar"),
        cancelButtonText: this.$t("Gral.cancelar"),
        iconColor: "red",
        reverseButtons: true,
      }).then((result) => {
        if (result.isConfirmed) {
          AlarmaSMSDataService.enviar(
            this.dispositivo.telefono +
              "," +
              "begin" +
              this.dispositivo.contrasena
          )
            .then((response) => {
              if (response.status == 200) {
                let txt = "IMEI"; //Texto para concatenar con el dato IMEI/Id
                switch (this.dispositivo.modelo) {
                  case "TKSTAR":
                    txt = "Id";
                    break;

                  case "TK108":
                    txt = "IMEI";
                    break;
                }
                this.accion =
                  "Reinicio de fábrica a " +
                  this.dispositivo.nombre +
                  " con " +
                  txt +
                  " " +
                  this.dispositivo.imei;
                this.registrarAccion();
                const Toast = this.$swal.mixin({
                  toast: true,
                  position: "top-end",
                  showConfirmButton: false,
                  timer: 5000,
                  timerProgressBar: true,
                  didOpen: (toast) => {
                    toast.addEventListener("mouseenter", this.$swal.stopTimer);
                    toast.addEventListener(
                      "mouseleave",
                      this.$swal.resumeTimer
                    );
                  },
                });

                Toast.fire({
                  icon: "success",
                  title: this.$t("vMonitoreo.msgReset"),
                  text: this.$t("vMonitoreo.msgTiempoResp"),
                });
                var dia = new Date().toJSON().slice(0, 10).replace(/-/g, "/");
                var today = new Date();
                var time = "";
                time = today.getHours() + ":" + today.getMinutes();
                if (today.getMinutes() < 10) {
                  time = today.getHours() + ":0" + today.getMinutes();
                }
              } else {
                const Toast = this.$swal.mixin({
                  toast: true,
                  position: "top-end",
                  showConfirmButton: false,
                  timer: 4000,
                  timerProgressBar: true,
                  didOpen: (toast) => {
                    toast.addEventListener("mouseenter", this.$swal.stopTimer);
                    toast.addEventListener(
                      "mouseleave",
                      this.$swal.resumeTimer
                    );
                  },
                });

                Toast.fire({
                  icon: "error",
                  title: this.$t("vMonitoreo.msgErrComandArduino"),
                });
              }
            })
            .catch(() => {
              const Toast = this.$swal.mixin({
                toast: true,
                position: "top-end",
                showConfirmButton: false,
                timer: 4000,
                timerProgressBar: true,
                didOpen: (toast) => {
                  toast.addEventListener("mouseenter", this.$swal.stopTimer);
                  toast.addEventListener("mouseleave", this.$swal.resumeTimer);
                },
              });

              Toast.fire({
                icon: "error",
                title: this.$t("vMonitoreo.msgErrReset"),
              });
            });
        }
      });
    },
    agregarAdmin() {
      if (this.alarma.listaAdmin != null) {
        if (this.alarma.listaAdmin.length == 10) {
          this.mensajeError = "";
          AlarmaSMSDataService.enviar(
            this.dispositivo.telefono +
              "," +
              "sos" +
              this.dispositivo.contrasena +
              " " +
              this.alarma.listaAdmin
          )
            .then((response) => {
              if (response.status == 200) {
                this.accion =
                  "Se configuró un SOS con el número " +
                  this.alarma.listaAdmin +
                  " para el dispositivo " +
                  this.dispositivo.nombre;
                this.registrarAccion();
                var admin = [];
                if (this.alarma.listaAdmin.length >= 10)
                  admin.push(this.alarma.listaAdmin);
                var data = {
                  id: this.alarma.id,
                  idDispositivo: this.configuracionActual.idDispositivo,
                  alarmaImpacto: this.configuracionActual.alarmaImpacto,
                  apagadoProfundo: this.configuracionActual.apagadoProfundo,
                  alarmaVelocidad: this.configuracionActual.alarmaVelocidad,
                  velocidad: this.configuracionActual.velocidad,
                  alarmaMovimiento: this.configuracionActual.alarmaMovimiento,
                  radio: this.configuracionActual.radio,
                  dormirTiempo: this.configuracionActual.dormirTiempo,
                  tiempoDormir: this.configuracionActual.tiempoDormir,
                  alarmaApagado: this.configuracionActual.alarmaApagado,
                  tipoApagado: this.configuracionActual.tipoApagado,
                  zonaHoraria: this.configuracionActual.zonaHoraria,
                  listaAdmin: admin,
                };
                sessionStorage.setItem("idAlarmaSMS", this.alarma.id);
                AlarmaSMSDataService.update(data)
                  .then(() => {})
                  .catch(() => {
                    const Toast = this.$swal.mixin({
                      toast: true,
                      position: "top-end",
                      showConfirmButton: false,
                      timer: 4000,
                      timerProgressBar: true,
                      didOpen: (toast) => {
                        toast.addEventListener(
                          "mouseenter",
                          this.$swal.stopTimer
                        );
                        toast.addEventListener(
                          "mouseleave",
                          this.$swal.resumeTimer
                        );
                      },
                    });

                    Toast.fire({
                      icon: "error",
                      title: this.$t("configDispositivos.msgErrActualizar"),
                    });
                  });

                const io = require("socket.io-client"),
                  ioClient = io.connect(
                    process.env.VUE_APP_URL_SERVER_SOCKET_ARDUINO
                  );

                var admin = [];
                if (this.alarma.listaAdmin.length >= 10)
                  admin.push(this.alarma.listaAdmin);

                var data = {
                  id: this.alarma.id,
                  idDispositivo: this.configuracionActual.idDispositivo,
                  alarmaImpacto: this.configuracionActual.alarmaImpacto,
                  apagadoProfundo: this.configuracionActual.apagadoProfundo,
                  alarmaVelocidad: this.configuracionActual.alarmaVelocidad,
                  velocidad: this.configuracionActual.velocidad,
                  alarmaMovimiento: this.configuracionActual.alarmaMovimiento,
                  radio: this.configuracionActual.radio,
                  dormirTiempo: this.configuracionActual.dormirTiempo,
                  tiempoDormir: this.configuracionActual.tiempoDormir,
                  alarmaApagado: this.configuracionActual.alarmaApagado,
                  tipoApagado: this.configuracionActual.tipoApagado,
                  zonaHoraria: this.configuracionActual.zonaHoraria,
                  listaAdmin: admin,
                };
                sessionStorage.setItem("idAlarmaSMS", this.alarma.id);
                AlarmaSMSDataService.update(data);

                ioClient.on("sms", (msg) => {
                  var trama = Jwt.jwtDecodeSms(msg);
                  var num = "",
                    b,
                    shock;
                  for (var i = 0; i < trama.length; i++) {
                    if (trama.substring(i, i + 1) == "|") {
                      b = i;
                    }
                  }
                  num = trama.substring(0, b - 1);
                  shock = trama.substring(b + 1, trama.length);
                  if (num == this.dispositivo.telefono) {
                    if (shock == "sosok" || shock == "sos ok") {
                      const Toast2 = this.$swal.mixin({
                        toast: true,
                        position: "top-end",
                        showConfirmButton: false,
                        timer: 4000,
                        timerProgressBar: true,
                        didOpen: (toast) => {
                          toast.addEventListener(
                            "mouseenter",
                            this.$swal.stopTimer
                          );
                          toast.addEventListener(
                            "mouseleave",
                            this.$swal.resumeTimer
                          );
                        },
                      });

                      Toast2.fire({
                        icon: "success",
                        title: this.$t("configDispositivos.msgSOSAdd"),
                      });
                    }
                    if (shock == "nosos ok" || shock == "no sos ok") {
                      const Toast2 = this.$swal.mixin({
                        toast: true,
                        position: "top-end",
                        showConfirmButton: false,
                        timer: 4000,
                        timerProgressBar: true,
                        didOpen: (toast) => {
                          toast.addEventListener(
                            "mouseenter",
                            this.$swal.stopTimer
                          );
                          toast.addEventListener(
                            "mouseleave",
                            this.$swal.resumeTimer
                          );
                        },
                      });

                      Toast2.fire({
                        icon: "success",
                        title: this.$t("configDispositivos.msgSOSDel"),
                      });
                    }
                  }
                });
              } else {
                const Toast = this.$swal.mixin({
                  toast: true,
                  position: "top-end",
                  showConfirmButton: false,
                  timer: 4000,
                  timerProgressBar: true,
                  didOpen: (toast) => {
                    toast.addEventListener("mouseenter", this.$swal.stopTimer);
                    toast.addEventListener(
                      "mouseleave",
                      this.$swal.resumeTimer
                    );
                  },
                });

                Toast.fire({
                  icon: "error",
                  title: this.$t("vMonitoreo.msgErrComandArduino"),
                });
              }
            })
            .catch(() => {
              const Toast = this.$swal.mixin({
                toast: true,
                position: "top-end",
                showConfirmButton: false,
                timer: 4000,
                timerProgressBar: true,
                didOpen: (toast) => {
                  toast.addEventListener("mouseenter", this.$swal.stopTimer);
                  toast.addEventListener("mouseleave", this.$swal.resumeTimer);
                },
              });

              Toast.fire({
                icon: "error",
                title: this.$t("configDispositivos.msgErrSentSolicitud"),
              });
            });
        } else {
          this.mensajeError = this.$t("configDispositivos.msgTelValido");
        }
      } else {
        this.mensajeError = this.$t("configDispositivos.msgAddTel");
      }
    },
    eliminarAdmin(dato) {
      this.accion =
        "Se eliminó un SOS con el número " +
        this.dispositivo.telefono +
        " para el dispositivo " +
        this.dispositivo.nombre;
      this.registrarAccion();
      AlarmaSMSDataService.enviar(
        this.dispositivo.telefono +
          "," +
          "nosos" +
          this.dispositivo.contrasena +
          " " +
          dato
      )
        .then((response) => {
          if (response.status == 200) {
            const Toast = this.$swal.mixin({
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 5000,
              timerProgressBar: true,
              didOpen: (toast) => {
                toast.addEventListener("mouseenter", this.$swal.stopTimer);
                toast.addEventListener("mouseleave", this.$swal.resumeTimer);
              },
            });

            Toast.fire({
              icon: "success",
              title: this.$t("configDispositivos.msgDelSOS"),
              text: this.$t("vMonitoreo.msgTiempoResp"),
            });
            const io = require("socket.io-client"),
              ioClient = io.connect(
                process.env.VUE_APP_URL_SERVER_SOCKET_ARDUINO
              );

            var admin = [];
            var data = {
              id: this.alarma.id,
              idDispositivo: this.configuracionActual.idDispositivo,
              alarmaImpacto: this.configuracionActual.alarmaImpacto,
              apagadoProfundo: this.configuracionActual.apagadoProfundo,
              alarmaVelocidad: this.configuracionActual.alarmaVelocidad,
              velocidad: this.configuracionActual.velocidad,
              alarmaMovimiento: this.configuracionActual.alarmaMovimiento,
              radio: this.configuracionActual.radio,
              dormirTiempo: this.configuracionActual.dormirTiempo,
              tiempoDormir: this.configuracionActual.tiempoDormir,
              alarmaApagado: this.configuracionActual.alarmaApagado,
              tipoApagado: this.configuracionActual.tipoApagado,
              zonaHoraria: this.configuracionActual.zonaHoraria,
              listaAdmin: admin,
            };
            sessionStorage.setItem("idAlarmaSMS", this.alarma.id);
            AlarmaSMSDataService.update(data)
              .then(() => {
                this.alarma.banAdmin = false;
                this.alarma.listaAdmin = null;
              })
              .catch(() => {
                const Toast = this.$swal.mixin({
                  toast: true,
                  position: "top-end",
                  showConfirmButton: false,
                  timer: 4000,
                  timerProgressBar: true,
                  didOpen: (toast) => {
                    toast.addEventListener("mouseenter", this.$swal.stopTimer);
                    toast.addEventListener(
                      "mouseleave",
                      this.$swal.resumeTimer
                    );
                  },
                });

                Toast.fire({
                  icon: "error",
                  title: this.$t("configDispositivos.msgErrActualizar"),
                });
              });

            ioClient.on("sms", (msg) => {
              var trama = Jwt.jwtDecodeSms(msg);
              var num = "",
                b,
                shock;
              for (var i = 0; i < trama.length; i++) {
                if (trama.substring(i, i + 1) == "|") {
                  b = i;
                }
              }
              num = trama.substring(0, b - 1);
              shock = trama.substring(b + 1, trama.length);
            });
          } else {
            const Toast = this.$swal.mixin({
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 4000,
              timerProgressBar: true,
              didOpen: (toast) => {
                toast.addEventListener("mouseenter", this.$swal.stopTimer);
                toast.addEventListener("mouseleave", this.$swal.resumeTimer);
              },
            });

            Toast.fire({
              icon: "error",
              title: this.$t("vMonitoreo.msgErrComandArduino"),
            });
          }
        })
        .catch(() => {
          const Toast = this.$swal.mixin({
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 4000,
            timerProgressBar: true,
            didOpen: (toast) => {
              toast.addEventListener("mouseenter", this.$swal.stopTimer);
              toast.addEventListener("mouseleave", this.$swal.resumeTimer);
            },
          });

          Toast.fire({
            icon: "error",
            title: this.$t("configDispositivos.msgErrSolDelSOS"),
          });
        });
    },
    /**
     * Método que envia los comandos de las configuraciones.
     */
    enviarComando(comando, mensaje) {
      for (var i in comando) {
        var a = comando[i];
        var m = mensaje[i];
        this.accion = m;
        this.registrarAccion();
        AlarmaSMSDataService.enviar(a)
          .then((response) => {
            if (response.status == 200) {
              const Toast = this.$swal.mixin({
                toast: true,
                position: "top-end",
                showConfirmButton: false,
                timer: 5000,
                timerProgressBar: true,
                didOpen: (toast) => {
                  toast.addEventListener("mouseenter", this.$swal.stopTimer);
                  toast.addEventListener("mouseleave", this.$swal.resumeTimer);
                },
              });

              Toast.fire({
                icon: "success",
                title: this.$t("configDispositivos.msgComandos"),
                text: this.$t("vMonitoreo.msgTiempoResp"),
              });
            } else {
              const Toast = this.$swal.mixin({
                toast: true,
                position: "top-end",
                showConfirmButton: false,
                timer: 4000,
                timerProgressBar: true,
                didOpen: (toast) => {
                  toast.addEventListener("mouseenter", this.$swal.stopTimer);
                  toast.addEventListener("mouseleave", this.$swal.resumeTimer);
                },
              });

              Toast.fire({
                icon: "error",
                title: this.$t("vMonitoreo.msgErrComandArduino"),
              });
            }
          })
          .catch(() => {
            const Toast = this.$swal.mixin({
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 4000,
              timerProgressBar: true,
              didOpen: (toast) => {
                toast.addEventListener("mouseenter", this.$swal.stopTimer);
                toast.addEventListener("mouseleave", this.$swal.resumeTimer);
              },
            });

            Toast.fire({
              icon: "error",
              title: this.$t("vMonitoreo.msgErrComandArduino"),
            });
          });
      }
    },
    /**
     * Método para el envio de vefirifcar estatus del dispositivo.
     */
    enviarCheck() {
      this.accion =
        "Solicitud de estatus del dispositivo " +
        this.dispositivo.nombre +
        " con el número " +
        this.dispositivo.telefono;
      this.registrarAccion();
      AlarmaSMSDataService.enviar(
        this.dispositivo.telefono + "," + "check123456"
      )
        .then((response) => {
          if (response.status == 200) {
            const Toast = this.$swal.mixin({
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 5000,
              timerProgressBar: true,
              didOpen: (toast) => {
                toast.addEventListener("mouseenter", this.$swal.stopTimer);
                toast.addEventListener("mouseleave", this.$swal.resumeTimer);
              },
            });

            Toast.fire({
              icon: "success",
              title: this.$t("configDispositivos.msgSolicitudEstatus"),
              text: this.$t("vMonitoreo.msgTiempoResp"),
            });
            const io = require("socket.io-client"),
              ioClient = io.connect(
                process.env.VUE_APP_URL_SERVER_SOCKET_ARDUINO
              );

            ioClient.on("sms", (msg) => {
              var trama = Jwt.jwtDecodeSms(msg);
              var datos,
                modelo,
                versionSoftware,
                id,
                ip,
                puerto,
                apn,
                gps,
                gsm,
                admin,
                sos,
                aux,
                aux2,
                long;
              trama = trama.replace("TK913", "XM_TK913");
              datos = trama.split("_");
              modelo = datos[1];
              versionSoftware = datos[3];
              versionSoftware = versionSoftware.substring(0, 3);
              id = datos[3].split("ID:");
              id = id[1];
              id = id.substring(0, 10);
              aux = datos[3].split("IP:");
              aux = aux[1].split("APN:");
              aux = aux[0].split(":");
              ip = aux[0];
              puerto = aux[1];
              aux = "";
              aux = datos[3].split("APN:");
              aux = aux[1].split(",");
              apn = aux[0];
              sos = aux[3];
              aux2 = aux[2];
              aux2 = aux2.split(":"); //"GPS 11GSM 13" "GPS 11GSM 132292442200"
              long = aux2[1].length;
              gps = aux2[1].substring(0, long - 3);
              long = 0;
              long = aux2[2].length;
              if (long > 2) {
                gsm = aux2[2].substring(0, long - 10);
                admin = aux2[2].substring(long - 10, long);
              } else {
                gsm = aux2[2];
                admin = 0;
              }

              //MODELO
              modelo = "Modelo: TKSTAR " + modelo;
              //VersionSoftware
              versionSoftware = "Versión de software: " + versionSoftware;
              //ID
              id = "ID: " + id;
              //GPS
              gps = "GPS: " + gps;
              //GSM
              gsm = "GSM: " + gsm;
              //APN
              apn = "APN: " + apn;
              //IP
              ip = "IP: " + ip;
              //PUERTO
              puerto = "Puerto: " + puerto;
              //ADMIN
              if (admin == 0) {
                admin = "Administrador: No configurado";
              } else {
                admin = "Administrador: " + admin;
              }
              //SOS
              if (sos !== null && sos !== "") {
                sos = "SOS: " + sos;
              } else {
                sos = "SOS: No configurado";
              }

              document.getElementById("textarea").value =
                modelo +
                "\n" +
                versionSoftware +
                "\n" +
                id +
                "\n" +
                gps +
                "\n" +
                gsm +
                "\n" +
                apn +
                "\n" +
                ip +
                "\n" +
                puerto +
                "\n" +
                admin +
                "\n" +
                sos;
              sessionStorage.setItem(
                "check",
                modelo +
                  "\n" +
                  versionSoftware +
                  "\n" +
                  id +
                  "\n" +
                  gps +
                  "\n" +
                  gsm +
                  "\n" +
                  apn +
                  "\n" +
                  ip +
                  "\n" +
                  puerto +
                  "\n" +
                  admin +
                  "\n" +
                  sos
              );
              sessionStorage.setItem("DisCheck", this.dispositivo.nombre);
              const Toast = this.$swal.mixin({
                toast: true,
                position: "top-end",
                showConfirmButton: false,
                timer: 5000,
                timerProgressBar: true,
                didOpen: (toast) => {
                  toast.addEventListener("mouseenter", this.$swal.stopTimer);
                  toast.addEventListener("mouseleave", this.$swal.resumeTimer);
                },
              });
              Toast.fire({
                icon: "success",
                title: this.$t("configDispositivos.msgRespuestaSolicitud"),
              });
            });
          } else {
            const Toast = this.$swal.mixin({
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 4000,
              timerProgressBar: true,
              didOpen: (toast) => {
                toast.addEventListener("mouseenter", this.$swal.stopTimer);
                toast.addEventListener("mouseleave", this.$swal.resumeTimer);
              },
            });

            Toast.fire({
              icon: "error",
              title: this.$t("vMonitoreo.msgErrComandArduino"),
            });
          }
        })
        .catch(() => {
          const Toast = this.$swal.mixin({
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 4000,
            timerProgressBar: true,
            didOpen: (toast) => {
              toast.addEventListener("mouseenter", this.$swal.stopTimer);
              toast.addEventListener("mouseleave", this.$swal.resumeTimer);
            },
          });

          Toast.fire({
            icon: "error",
            title: this.$t("configDispositivos.msgErroEstatus"),
          });
        });
    },
    registrarAccion() {
      var data = {
        usuario: this.usuarioLogueado,
        accion: this.accion + sessionStorage.infoDevice,
        fechaCreacion: new Date(),
        tipo: "configuracion",
      };
      AccionesDataService.create(data);
    },
  },
};
</script>

<style scoped>
.alineado-titulo-form {
  text-align: start;
}

.styleTitle {
  font-size: 25px;
  font-weight: bold;
  color: rgb(12, 33, 92);
  margin-top: -20px;
  margin-bottom: 20px;
}

#txtAlign {
  text-align: center;
}

@media (max-width: 991.98px) and (max-height: 950px) {
  #txtAlign {
    text-align: center;
  }
}

.layered.box {
  box-shadow: 0 1px 1px hsl(0deg 0% 0% / 0.075),
    0 2px 2px hsl(0deg 0% 0% / 0.075), 0 4px 4px hsl(0deg 0% 0% / 0.075),
    0 8px 8px hsl(0deg 0% 0% / 0.075), 0 16px 16px hsl(0deg 0% 0% / 0.075);
}

.box {
  border-radius: 8px;
}

.layered2.box2 {
  box-shadow: 0 1px 1px hsl(0deg 0% 0% / 0.075),
    0 2px 2px hsl(0deg 0% 0% / 0.075), 0 4px 4px hsl(0deg 0% 0% / 0.075),
    0 8px 8px hsl(0deg 0% 0% / 0.075), 0 16px 16px hsl(0deg 0% 0% / 0.075);
}

.box2 {
  border-radius: 8px;
}

.ancho-icono-boton {
  max-width: 80px;
}

@media (max-width: 959px) {
  .margin-top-div {
    margin-top: -22px;
  }
}

@media (min-width: 960px) {
  .margin-top-div {
    margin-top: 0px;
  }
}

@media (max-width: 991px) {
  .ancho-icono-boton {
    width: 50px !important
  }
}

@media (min-width: 992px) {
  .ancho-boton {
    width: 200px;
  }
}

@media (min-width: 1200px) {
  .ancho-boton {
    width: 300px !important;
  }
}
</style>
